var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/category"
  }, /*#__PURE__*/React.createElement("g", {
    id: "category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16699 8.33268H5.83366C7.50033 8.33268 8.33366 7.49935 8.33366 5.83268V4.16602C8.33366 2.49935 7.50033 1.66602 5.83366 1.66602H4.16699C2.50033 1.66602 1.66699 2.49935 1.66699 4.16602V5.83268C1.66699 7.49935 2.50033 8.33268 4.16699 8.33268Z",
    stroke: "#0963EB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.167 8.33268H15.8337C17.5003 8.33268 18.3337 7.49935 18.3337 5.83268V4.16602C18.3337 2.49935 17.5003 1.66602 15.8337 1.66602H14.167C12.5003 1.66602 11.667 2.49935 11.667 4.16602V5.83268C11.667 7.49935 12.5003 8.33268 14.167 8.33268Z",
    stroke: "#0963EB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.167 18.3327H15.8337C17.5003 18.3327 18.3337 17.4993 18.3337 15.8327V14.166C18.3337 12.4993 17.5003 11.666 15.8337 11.666H14.167C12.5003 11.666 11.667 12.4993 11.667 14.166V15.8327C11.667 17.4993 12.5003 18.3327 14.167 18.3327Z",
    stroke: "#0963EB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.16699 18.3327H5.83366C7.50033 18.3327 8.33366 17.4993 8.33366 15.8327V14.166C8.33366 12.4993 7.50033 11.666 5.83366 11.666H4.16699C2.50033 11.666 1.66699 12.4993 1.66699 14.166V15.8327C1.66699 17.4993 2.50033 18.3327 4.16699 18.3327Z",
    stroke: "#0963EB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.69a805711ae7b1beffd62daf94c10160.svg";
export { ForwardRef as ReactComponent };